// @ts-expect-error folder not yet converted to TS
import LoginFailureHandlerFactory from '../lib/LoginFailureHandlerFactory';
import googleLoginNonce from '../lib/googleLoginNonce';
import GoogleLoginDao from '../data/GoogleLoginDao';
const googleLoginDao = new GoogleLoginDao();
export const loginWithGoogleAndRedirect = (credentials, handleError, history) => {
  const triggerReset = () => handleError('LOGIN_UNAVAILABLE');

  googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndRedirect).catch(LoginFailureHandlerFactory.createRavenReporter('Google initialization failed', triggerReset, history.push));
};